/* eslint-disable max-lines */
import TabletLayout from '@App/components/TabletLayout/TabletLayout';
import WebLayout from '@App/components/WebLayout/WebLayout';
import MonitorLayout from '@App/components/MonitorLayout/MonitorLayout';
import NoMatch from '@App/pages/NoMatch/NoMatch';
import Question1 from '@App/pages/Monitor/Question1/Question1';
import Question1Form from '@App/pages/Tablet/Question1/Question1Form';
import Question2 from '@App/pages/Monitor/Question2/Question2';
import Question2Form from '@App/pages/Tablet/Question2/Question2Form';
import Question3 from '@App/pages/Monitor/Question3/Question3';
import Question3Form from '@App/pages/Tablet/Question3/Question3Form';
import Question4 from '@App/pages/Monitor/Question4/Question4';
import Question4Form from '@App/pages/Tablet/Question4/Question4Form';
import Question5 from '@App/pages/Monitor/Question5/Question5';
import Question5Form from '@App/pages/Tablet/Question5/Question5Form';
import Monitor from '@App/pages/Monitor/Monitor';
import Introduction from '@App/pages/Tablet/Introduction/Introduction';
import WebIntroduction from '@App/pages/Web/Introduction/Introduction';

const isMuseumMode = import.meta.env.VITE_APP_MODE === 'museum'
  || import.meta.env.VITE_IS_MUSEUM === 'true';

const routes = [
  {
    path: '/',
    element: <WebLayout />,
    children: [
      {
        index: true,
        element: <WebIntroduction />,
      },
      {
        path: 'question1', 
        element: <Question1 withInputFields />,
        handle: { title: 'Question 1' },
      },
      {
        path: 'question2',
        element: <Question2 withInputFields />,
        handle: { title: 'Question 2' },
      },
      {
        path: 'question3',
        element: <Question3 withInputFields />,
        handle: { title: 'Question 3' },
      },
      {
        path: 'question4',
        element: <Question4 withInputFields />,
        handle: { title: 'Question 4' },
      },
      {
        path: 'question5',
        element: <Question5 withInputFields />,
        handle: { title: 'Question 5' },
      },
    ],
  },
  {
    path: '/monitor',
    element: <MonitorLayout />,
    children: [
      {
        index: true,
        element: <Monitor />,
        handle: { title: 'Monitor panels' },
      },
    ],
  },
  {
    path: '/tablet/:tabletId',
    element: <TabletLayout />,
    children: [
      {
        index: true,
        element: <Introduction />,
      },
      {
        path: 'question1', 
        element: <Question1Form />,
        handle: { title: 'Question 1' },
      },
      {
        path: 'question2',
        element: <Question2Form />,
        handle: { title: 'Question 2' },
      },
      {
        path: 'question3',
        element: <Question3Form />,
        handle: { title: 'Question 3' },
      },
      {
        path: 'question4',
        element: <Question4Form />,
        handle: { title: 'Question 4' },
      },
      {
        path: 'question5',
        element: <Question5Form />,
        handle: { title: 'Question 5' },
      },
    ],
  },
  {
    path: '*', 
    element: <NoMatch />,
    handle: { title: 'Page Not Found' },
  },
];

export default routes.filter((route) => {
  if (import.meta.env.VITE_NAZKA_ENV === 'development') {
    return true;
  }

  if (isMuseumMode) {
    return route.path !== '/';
  }

  return route.path !== '/tablet/:tabletId' && route.path !== '/monitor';
});